export default __webpack_public_path__ + "static/media/Avatar.8ad69fe5.svg";